var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-shell"},[_c('EmptyState',{attrs:{"title":"暂未开放访问","description":"当前账号没有访问该页面的权限，请联系管理员配置菜单权限。","icon":"el-icon-lock"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("返回工作台")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }